import withLazyLoading from '../../hoc/withLazyLoading';
import { createCrumbHandle } from '../../utilities/auth';
import withPostHogTracker from '../../composeRouter';
import {loader as escalationDetailsLoader} from '../../components/Escalation/components/EscalationForm';
import { QueryClient } from '@tanstack/react-query';
import { EVERYONE, PEOPLE_RULES, PLANT_RULES, access } from '../../access';

const UserListPage = withLazyLoading(
  () => import('../../pages/user-management/components/UserListPage')
);
const UserCreatePage = withLazyLoading(
  () => import('../../pages/user-management/components/UserCreatePage')
);
const UserInvitePage = withLazyLoading(
  () => import('../../pages/user-management/components/UserInvitePage')
);
const UserEditPage = withLazyLoading(
  () => import('../../pages/user-management/components/UserEditPage')
);
const EscalationList = withLazyLoading(
  () => import('../../components/Escalation/components/EscalationList')
);
const EscalationFormWrapper = withLazyLoading(
  () => import('../../components/Escalation/components/EscalationForm')
);

const CommunicationModule = withLazyLoading(
  () => import ('../../components/CommunicationModule/components/CommunicationModuleView')
)

const userRoutes =  (queryClient: QueryClient) => [
  {
    path: '/userList',
    handle: createCrumbHandle('Users'),
    children: [
      {
        index: true,
        element: withPostHogTracker(<UserListPage />),
        handle: access(PEOPLE_RULES.userList),
      },
      {
        path: 'editUser/:id',
        element: withPostHogTracker(<UserEditPage />),
        handle: { ...createCrumbHandle('Edit User'), ...access(PEOPLE_RULES.userList) },
      },
      {
        path: 'createUser',
        element: withPostHogTracker(<UserCreatePage />),
        handle: { ...createCrumbHandle('Create User'), ...access(PEOPLE_RULES.userList) },
      },
      {
        path: 'inviteUser/:invitedUserId?',
        element: withPostHogTracker(<UserInvitePage />),
        handle: { ...createCrumbHandle('Invite User'), ...access(PEOPLE_RULES.userList) },
      },
    ]
  },
  {
    path: '/escalation',
    handle: createCrumbHandle('Escalation'),
    children: [
      {
        index: true,
        element: withPostHogTracker(<EscalationList />),
        handle: access(PLANT_RULES.escalation),
      },
      {
        path: 'create',
        element: withPostHogTracker(<EscalationFormWrapper />),
        handle: { ...createCrumbHandle('Create Escalation'), ...access(PLANT_RULES.escalation) },
      },
      {
        path: ':escalationId',
        element: withPostHogTracker(<EscalationFormWrapper />),
        loader: escalationDetailsLoader(queryClient),
        handle: { ...createCrumbHandle('Edit Escalation'), ...access(PLANT_RULES.escalation) },
      },
    ]
  },
  {
    path: '/communication',
    element: withPostHogTracker(<CommunicationModule />),
    handle: { ...createCrumbHandle('Communication'), ...access(EVERYONE) },
  }
];

export default userRoutes;
